import { useState, useEffect, useContext } from "react";
import isEmpty from "lodash/isEmpty";
import { AuthContext } from "../../Contexts/AuthContext";
import { fetchRemoteConfigJson } from "../../helper/remoteConfigHelper";

const useFetchHeaderTabVisibility = () => {
  const { currentUser } = useContext(AuthContext);
  const uid = currentUser?.uid;

  const [isLoading, setIsLoading] = useState(false);
  const [isGotResponse, setIsGotResponse] = useState(false);
  const [isShowHeader, setIsShowHeader] = useState({
    isShowResumeTab: false,
    isShowCoverLetterTab: false,
    isShowResumeWriterTab: false,
    isShowAiToolsTab: false,
  });

  const fetchConfigData = async () => {
    setIsLoading(true);
    const response = await fetchRemoteConfigJson("header_tab_visibility", null);
    if (!isEmpty(response)) {
      setIsShowHeader(response);
      setIsGotResponse(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (uid) {
      fetchConfigData();
    }
  }, [uid]);

  return {
    isLoading,
    isGotResponse,
    isShowHeader,
  };
};

export default useFetchHeaderTabVisibility;
